<template>
  <button
      type="button"
      class="switch-pro-button"
      @click="onClick"
  >
    <span class="switch-pro-button__content">
      <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
      >
        <path
            d="M18.3566 6.90656C18.538 6.9285 18.7085 7.00109 18.8464 7.11511C18.9847 7.22847 19.0843 7.3783 19.1326 7.54553C19.1809 7.71277 19.1757 7.88985 19.1176 8.05425L16.2911 16.2666C16.2627 16.3494 16.215 16.4251 16.1515 16.488C16.088 16.5508 16.0105 16.5994 15.9245 16.6299C15.8386 16.6605 15.7465 16.6723 15.6551 16.6645C15.5637 16.6567 15.4753 16.6294 15.3965 16.5848C15.379 16.5746 13.4256 15.5072 9.9972 15.5072C6.56876 15.5072 4.61543 16.5746 4.59633 16.5855C4.51758 16.6297 4.42936 16.6566 4.33818 16.6642C4.24701 16.6717 4.15521 16.6597 4.06956 16.6291C3.98392 16.5985 3.90661 16.5501 3.84335 16.4873C3.78009 16.4246 3.7325 16.3492 3.70408 16.2666L0.8776 8.05208C0.82111 7.88772 0.81705 7.7112 0.865931 7.54467C0.914812 7.37813 1.01446 7.229 1.15236 7.11599C1.29026 7.00298 1.46028 6.93112 1.64108 6.90944C1.82188 6.88775 2.0054 6.9172 2.16861 6.99409L6.0027 8.80571L9.20502 3.75783C9.28734 3.62836 9.40353 3.52125 9.54233 3.44691C9.68112 3.37256 9.83781 3.3335 9.9972 3.3335C10.1566 3.3335 10.3133 3.37256 10.4521 3.44691C10.5909 3.52125 10.7071 3.62836 10.7894 3.75783L13.9917 8.80353L17.8273 6.99192C17.9909 6.91434 18.1751 6.88463 18.3566 6.90656Z"
            fill="currentColor"
        />
      </svg>

      <span class="switch-pro-button__count">
        <template v-if="isUnlimited">
          <svg
              class="switch-pro-button__infinity"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
            <path
                d="M11.4583 7.81254L11.6666 7.50004C12.1913 6.80043 12.9228 6.28365 13.7576 6.0229C14.5923 5.76215 15.4879 5.77065 16.3175 6.04719C17.1472 6.32374 17.8688 6.85431 18.3801 7.56375C18.8914 8.27319 19.1666 9.12553 19.1666 10C19.1666 10.8746 18.8914 11.7269 18.3801 12.4363C17.8688 13.1458 17.1472 13.6763 16.3175 13.9529C15.4879 14.2294 14.5923 14.2379 13.7576 13.9772C12.9228 13.7164 12.1913 13.1996 11.6666 12.5L8.33325 7.50004C7.80855 6.80043 7.07702 6.28365 6.24228 6.0229C5.40755 5.76215 4.51194 5.77065 3.6823 6.04719C2.85267 6.32374 2.13108 6.85431 1.61974 7.56375C1.10841 8.27319 0.833252 9.12553 0.833252 10C0.833252 10.8746 1.10841 11.7269 1.61974 12.4363C2.13108 13.1458 2.85267 13.6763 3.6823 13.9529C4.51194 14.2294 5.40755 14.2379 6.24228 13.9772C7.07702 13.7164 7.80855 13.1996 8.33325 12.5L8.61159 12.0834"
                stroke="currentColor"
                stroke-width="1.3"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
          </svg>
        </template>
        <template v-else>
          {{ availableLeadsCounter }}
        </template>
      </span>
    </span>

    <span class="switch-pro-button__text">
      {{ textButton }}
    </span>
  </button>
</template>

<script>
export default {
  name: "SwitchProButton",
  emits: ["click"],
  props: {
    availableLeadsCounter: { type: [String, Number], required: true },
    textButton: { type: String, required: true },
    isUnlimited: { type: Boolean, default: false },
  },
  methods: {
    onClick() {
      this.$emit("click");
    },
  },
};
</script>

<style scoped>
.switch-pro-button {
  max-width: 230px;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  flex-wrap: nowrap;
  border-radius: 8px;
  border: 1px solid #EFF1FF;
  background: #FFFFFF;
  cursor: pointer;
  color: #3749C0;
  transition: background-color 0.15s ease, box-shadow 0.15s ease;
}

.switch-pro-button:hover {
  background-color: #EFF1FF;
  border-color: #3749C0;
}

.switch-pro-button:active {
  background-color: #EFF1FF;
  box-shadow: inset 0 0 8px rgba(44, 35, 35, 0.14);
}

.switch-pro-button__content {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: nowrap;
}

.switch-pro-button__text {
  font-weight: bold;
  line-height: 20px;
  color: inherit;
  white-space: nowrap;
  display: inline-block;
  transform-origin: center center;
  will-change: transform;
}

.switch-pro-button:hover .switch-pro-button__text {
  animation: switchProTextFloat 0.8s ease-in-out infinite;
}

@keyframes switchProTextFloat {
  0% { transform: translateY(0) rotate(0deg); }
  25% { transform: translateY(-1px) rotate(-0.6deg); }
  50% { transform: translateY(0) rotate(0deg); }
  75% { transform: translateY(-1px) rotate(0.6deg); }
  100% { transform: translateY(0) rotate(0deg); }
}

.switch-pro-button__count {
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  color: inherit;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
</style>
